import React, { useEffect } from 'react'
import PartnershipStyles from "./Feedback.module.css"
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined'
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

// function createData(id, name, email, number, date, job) {
//     return { id, name, email, number, date, job };
// }

const rows = [];


const Feedback = () => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        bgcolor: 'background.paper',
        // border: '2px solid gray',
        // boxShadow: '2px 2px 10px 2px gray',
        borderRadius: '5px',
        p: 4,
    };

    const [selectedData, setSelectedData] = useState({})
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [view, setView] = useState(false)
    const handleView = (row) => {
        setView(true)
        console.log(row)
        setSelectedData(row)

    }
    const handleViewClose = () => setView(false)

    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()


    const [data, setData] = useState([])

    const getApplicantData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/feedback/getAllFeedBack`
            )
            setData(res.data)
            // console.error("helloss")
            console.log(res.data)
            // console.log(res.data[0].jobrole[0].resume[0].userAppForm.applicantName)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getApplicantData();

    }, [])





    const [jobRole, setJobRole] = React.useState("");

    const handleJobRoles = (event) => {
        setJobRole(event.target.value);
    };

    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    const [query, setQuery] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // const [view, setView] = useState(false)
    // const handleView = (row) => {
    //     setView(true)
    //     console.log(row)
    //     setSelectedData(row)

    // }
    // const handleViewClose = () => setView(false)

    const deleteApplicantbyId = async (feedbackId) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/feedback/deleteFeedbackFormById/${feedbackId}`
            )
            // console.log(res)
            // this is the snipte for the notification
            dispatch(fetchNotifications())

            dispatch(setNotificationCount({
             count:count+1,
            }))

            //   uptill here 

            alert('Delete Successful!')
            // window.location.reload()
            getApplicantData();
        } catch (error) {
            console.log(error);
        }
    }

    // const filteredData = data.flatMap((category) =>
    //     category.jobrole
    //         .filter((job) => {
    //             if (jobRole === 'All Roles') {
    //                 return true; // Include all job roles
    //             } else {
    //                 return job.careerJobRoleName.includes(jobRole); // Filter based on jobRole
    //             }
    //         })
    //         .flatMap((job) =>
    //             job.resume.filter((row) =>
    //                 row.userAppForm.applicantName.toLowerCase().includes(query)
    //             )
    //                 .map((row) => (
    //                     {
    //                         careerCategoryName: category.careerCategoryName,
    //                         careerJobRoleName: job.careerJobRoleName,
    //                         job: job,
    //                         ...row,
    //                     }
    //                 ))
    //         )
    // );




    //   console.log(filteredData)


    return (
        <>
            <Card sx={{ maxWidth: '95%', border: 'none', outline: 'none', boxShadow: 'none', mt: '3%' }}>
                <CardContent>
                    <Paper className={PartnershipStyles.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={PartnershipStyles.jobApplicantListBox1}>
                                <Box className={PartnershipStyles.Box1}>
                                    <Typography variant='h5'>Feedback</Typography>
                                    <Typography variant='h6'>12 entries</Typography>
                                </Box>
                                {/* <Link to='/addfeedback'>
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Feedback</Button>
                    </Link> */}
                            </div>
                            <div className={PartnershipStyles.jobApplicantListBox2}>
                                <Box className={PartnershipStyles.Box1}>
                                    <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '#121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                                {/* <Box className={PartnershipStyles.Box2}>
                                    Filter by
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={jobRole}
                                            // filter={job.careerJobRoleName}
                                            onChange={handleJobRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{height:'5vh'}}
                                        >

                                            <MenuItem value="">All Roles</MenuItem>
                                            <MenuItem value='Javascript'>Javascript</MenuItem>
                                            <MenuItem value='Technical'>Technical</MenuItem>
                                            <MenuItem value='React JS Developer'>React JS Developer</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box> */}
                            </div>
                            <Table stickyHeader aria-label="sticky table" sx={{mt:'2%'}}>
                                <TableHead>
                                    <TableRow className={PartnershipStyles.Mainhead}>
                                        <TableCell className={PartnershipStyles.Tablehead}>User</TableCell>
                                        {/* <TableCell className={PartnershipStyles.Tablehead}>Phone number</TableCell> */}

                                        <TableCell className={PartnershipStyles.Tablehead}>Occupation</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Submitted on</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>IpAddress</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Message</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {

                                        data
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => {
                                                return (
                                                    <TableRow className={PartnershipStyles.MainRow} hover role="checkbox" tabIndex={-1} key={row.feedbackId} >
                                                        <TableCell className={PartnershipStyles.Tablerow1}> {row.feedbackName}<Box className={PartnershipStyles.Email}>{row.feedbackEmail}</Box></TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.feedbackDesignation}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>{row.feedbackDate} </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.feedbackIpAddress}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.feedbackSuggestions.substr(0, 8) + '...'}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow2}>

                                                            <VisibilityOutlinedIcon className={PartnershipStyles.Tableicon} onClick={() => handleView(row)} />
                                                            <Modal
                                                                open={view}
                                                                onClose={handleViewClose}
                                                                aria-labelledby="modal-modal-title"
                                                                aria-describedby="modal-modal-description"
                                                                BackdropProps={{
                                                                    timeout: 500,
                                                                    style: { backgroundColor: '#454545',opacity:'30%' } 
                                                                  }}
                                                                  slotProps={{
                                                                    backdrop: {
                                                                      timeout: 500,
                                                                    },
                                                                  }
                                                        }

                                                            >
                                                                <Box sx={style} className={PartnershipStyles.formStart}>
                                                                    <form action='' method=''>
                                                                        <label>User</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <input text='text' value={selectedData?.feedbackName} disabled></input>
                                                                        </Box>

                                                                        <label>Email</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <input text='text' value={selectedData?.feedbackEmail} disabled></input>
                                                                        </Box>
                                                                        <label>Occupation</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <input text='text' value={selectedData?.feedbackDesignation} disabled></input>
                                                                        </Box>
                                                                        <label>Submitted on</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <input text='text' value={selectedData?.feedbackDate} disabled></input>
                                                                        </Box>
                                                                        <label>IpAddress</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <input text='text' value={selectedData?.feedbackIpAddress} disabled></input>
                                                                        </Box>
                                                                        <label>Message</label>
                                                                        <Box className={PartnershipStyles.form}>
                                                                            <textarea text='text' value={selectedData?.feedbackSuggestions} disabled></textarea>
                                                                        </Box>
                                                                        {/* <label>Action</label>
                                                                        <Box className={PartnershipStyles .form}>
                                                                        <input text='text' value={selectedData?.role} disabled></input>
                                                                        </Box> */}
                                                                    </form>
                                                                </Box>
                                                            </Modal>
                                                            {/* <DeleteForeverOutlinedIcon className={PartnershipStyles.Tableicon} style={{ marginLeft: '10%' }} /> */}



                                                            {/* <Link to={ `/addfeedback/${row?.feedbackId}`} state={{row:row}}>                           
                                                                <VisibilityOutlinedIcon className={PartnershipStyles.Tableicon} />
                                                            </Link>  */}
                                                            <Link disableRipple onClick={() => deleteApplicantbyId(row.feedbackId)}> 
                                                                <DeleteForeverOutlinedIcon style={{marginLeft:'10%'}} className={PartnershipStyles.Tableicon} />
                                                           </Link> 
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })

                                    }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{ paddingTop: '2%' }}

                        />
                    </Paper>
                </CardContent>
            </Card>
        </>
    )
}

export default Feedback